<script>
export default {
    name: "render-vnode",
    props: {
        vNode: Object,
    },
    setup(props) {
        return () => props.vNode;
    },
};
</script>
